var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4094_31218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75002 1.25V2.58333M3.00002 8.33333H1.66669M4.54268 4.12614L3.59987 3.18333M12.9582 4.12614L13.901 3.18333M15.8334 8.33333H14.5M5.41675 8.3334C5.41675 6.49245 6.90913 5.00006 8.75008 5.00006C10.0051 5.00006 11.0981 5.69363 11.6667 6.71838M5.00002 18.3333C3.15907 18.3333 1.66669 16.8409 1.66669 15C1.66669 13.1591 3.15907 11.6667 5.00002 11.6667C5.38684 11.6667 5.75828 11.7326 6.10371 11.8537C6.70053 10.283 8.21991 9.16667 10 9.16667C11.7801 9.16667 13.2995 10.283 13.8963 11.8537C14.2418 11.7326 14.6132 11.6667 15 11.6667C16.841 11.6667 18.3334 13.1591 18.3334 15C18.3334 16.8409 16.841 18.3333 15 18.3333C11.1331 18.3333 8.23269 18.3333 5.00002 18.3333Z",
    stroke: "#FDB022",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4094_31218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSun);
export default __webpack_public_path__ + "static/media/cloud-sun.573a9d49cc38c42d370af2fc83b0916c.svg";
export { ForwardRef as ReactComponent };